import {Component, OnDestroy, OnInit, Optional} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
import {HelpdeskService} from './helpdesk.service';
import {takeUntil} from 'rxjs/operators';
import {IdName} from 'src/app/shared/common-interfaces';
import {NotificationService} from 'src/app/shared/notification.service';
import PackageInfo from '../../../../package.json';
import {DeviceDetectorService} from 'ngx-device-detector';
import moment from 'moment';
import {MatDialogRef} from '@angular/material/dialog';

export interface IHelpdeskTicket  {
  appVersion: string;
  browser: string;
  createdOn?: string;
  deviceModel?: string;
  deviceOSVersion?: string;
  moduleName: string;
  problemDescription: string;
}


@Component({
    selector: 'app-helpdesk-ticket',
    templateUrl: './helpdesk-ticket.component.html',
    styleUrls: ['./helpdesk-ticket.component.scss'],
    standalone: false
})
export class HelpdeskTicketComponent implements OnInit, OnDestroy  {

  private destroyed$: Subject<void> = new Subject<void>();
  public readonly VERSION: string = PackageInfo.version;
  htForm: FormGroup;
  modules: IdName[] = [];
  deviceInfo = null;

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private helpdeskService: HelpdeskService,
    public notificationService: NotificationService,
    private deviceService: DeviceDetectorService,
    @Optional() public dialogRef: MatDialogRef<HelpdeskTicketComponent>,
    ) {
      this.deviceInfo = this.deviceService.getDeviceInfo();
  }

  ngOnInit() {
    this.htForm = this.formBuilder.group({
      module: ['', [Validators.required]],
      description: ['', [Validators.required]],
    });
    this.getModules();
  }

  send(e: MouseEvent) {
    e.preventDefault();

    const params: IHelpdeskTicket = {
      appVersion: this.VERSION,
      browser: this.deviceInfo.browser,
      moduleName: this.htForm.get('module').value,
      problemDescription: this.htForm.get('description').value,
      createdOn: moment().toISOString(),
    };

    this.helpdeskService.sendTicket(params)
    .pipe(takeUntil(this.destroyed$))
    .subscribe((response) => {
      if (response === null) {
        const message = this.translateService.stream(marker('Ticket sent successfully!'));
        this.notificationService.success(message);
        this.dialogRef.close(false);
      }
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private getModules() {
    this.helpdeskService.getModules()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(modules => {
        this.modules = modules;
      });
  }
}

